/**
 * Returns changelog event type icon.
 * @param {string} type
 * @returns {string} Event Type Icon
 */
export const getEventTypeIcon = type => {
  switch (type) {
    case 'bugfix':
      return 'bug'

    case 'feature':
      return 'trophy'

    case 'improvement':
      return 'wizard'

    default:
      return 'warning sign'
  }
}

/**
 * Returns changelog event type string.
 * @param {string} type
 * @returns {string} Event Type String
 */
export const getEventTypeString = type => {
  switch (type) {
    case 'bugfix':
      return 'Bugfix'

    case 'feature':
      return 'Feature'

    case 'improvement':
      return 'Improvement'

    default:
      return type
  }
}
